import po from '@/api/purchase-order'

import { baseMutations, baseState } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  suppliers: [],
  products: [],
  uom: [],
  is_received: undefined
}

export const getters = {
  uomGetter: state => ObjectRow => {
    let result = state.products.filter(
      p => p.product_id == ObjectRow.product_id
    )
    if (result.length > 0) {
      return state.uom.filter(u => u.uom_cat_id == result[0].uom_cat_id)
    }
    return []
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_SUPPLIER(state, data) {
    state.suppliers = data
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_UOM(state, data) {
    state.uom = data
  },
  SET_IS_RECEIVED(state, data) {
    state.is_received = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      {
        ...attrubutes, filter: {
          is_received: context.state.is_received
        }
      }
    )
    return po.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return po.store(data)
  },

  update(context, data) {
    return po.update(data)
  },
  destroy(context, id) {
    return po.destroy(id)
  },

  async find(context, id) {
    const response = await po.find(id)
    context.commit('SET_EDIT_DATA', response.data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.suppliers.length > 0) {
      let response = await po.getSupplier()
      context.commit('SET_SUPPLIER', response)
    }
    if (!context.state.products.length > 0) {
      let response = await po.getProduct()
      context.commit('SET_PRODUCT', response)
    }
    if (!context.state.uom.length > 0) {
      let response = await po.getUOM()
      context.commit('SET_UOM', response)
    }
    return Promise.resolve()
  },

  printPdf(context, id) {
    return po.printPdf(id)
  }
}
